import { render, staticRenderFns } from "./LandingUsage.vue?vue&type=template&id=3c3ed380&scoped=true"
import script from "./LandingUsage.vue?vue&type=script&lang=js"
export * from "./LandingUsage.vue?vue&type=script&lang=js"
import style0 from "./LandingUsage.vue?vue&type=style&index=0&id=3c3ed380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3ed380",
  null
  
)

export default component.exports